import { render, staticRenderFns } from "./VerticalNavMenu.vue?vue&type=template&id=f83c559c&scoped=true&"
import script from "./VerticalNavMenu.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenu.vue?vue&type=style&index=0&id=f83c559c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83c559c",
  null
  
)

export default component.exports